import React, { useState } from "react";
import { Grid, Paper ,Accordion, AccordionSummary, AccordionDetails, Typography} from "@mui/material";
import AccountDetailsForm from "./AccountDetailsForm";
import PaymentForm from "./PaymentForm";
import OrderSummary from "./OrderSummary";
import { useLocation } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Check from '@mui/icons-material/Check';




const CheckoutPage = ({}) => {
    const location = useLocation();
    const plan = location.state?.plan;
    const start_at = location.state?.start_at;

    const [step, setStep] = useState(1);
    const [expanded, setExpanded] = useState("account");
    const [formData, setFormData] = useState({});
    const [paymentData, setPaymentData] = useState({});
    const [accountCompleted, setAccountCompleted] = useState(false);
    const [userId, setUserId] = useState(localStorage.getItem("user_id") || null);


    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const isUpgrade = start_at != null && start_at !== "";
    return (
        <Grid container spacing={3} sx={{ mt: 1, px: { xs: 0, sm: 2 } }}>
            <Grid size={{ xs: 12, sm: 6 }}>
                {/* Account Details Accordion */}
                <Accordion
                    expanded={expanded === "account"}
                    onChange={handleAccordionChange("account")}
                    sx={{mb:2}}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="account-details-content"
                        id="account-details-header"
                    >
                        <Typography variant="h3" fontWeight="bold"> 1️⃣ Account Details &nbsp;
                            {accountCompleted && (<Check sx={{ color: "success.main", fontSize: "2rem", verticalAlign: "middle" }} />)}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <AccountDetailsForm
                            // active={true}
                            data={formData}
                            isUpgrade={isUpgrade}
                            onContinue={(data) => {
                                setFormData(data);
                                setAccountCompleted(true);
                                setExpanded("payment")
                            }}
                            onEdit={() => setStep(1)}
                        />
                    </AccordionDetails>
                </Accordion>

                {/* Payment Accordion */}
                <Accordion
                    expanded={expanded === "payment"}
                    onChange={handleAccordionChange("payment")}
                    disabled={!accountCompleted}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="payment-content"
                        id="payment-header"
                    >
                        <Typography variant="h3" fontWeight="bold"> 2️⃣ Payment </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <PaymentForm
                            active={expanded === "payment"}
                            customer={formData}
                            subscriptionPlan={plan}
                            onContinue={(data) => {
                                setPaymentData(data);
                            }}
                            userData ={formData}
                            // onSuccess={(res) => setStep(2)}
                            start_at={start_at}
                        />
                    </AccordionDetails>
                </Accordion>
            </Grid>

            {/* Order Summary */}
            <Grid size={{ xs: 12, sm: 6 }}>
                <OrderSummary plan={plan} />
            </Grid>
        </Grid>
    );
};

export default CheckoutPage;
